import {  SearchIcon} from "@chakra-ui/icons";
import {
  Flex,
  IconButton,
  InputGroup,
  InputLeftElement,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";

import React from "react";
import {SearchBar} from "./SearchBar/SearchBar";
import SidebarResponsive from "../Sidebar/SidebarResponsive";
import {useSignOut} from "react-auth-kit";
import {useNavigate} from "react-router-dom";
import { FiLogOut } from 'react-icons/fi';
import {HiOutlineLightBulb} from "react-icons/hi";

export default function AdminNavbarLinks(props) {
  const {  secondary, ...rest } = props;

  const { toggleColorMode } = useColorMode();
  const signOut = useSignOut()
  const navigate = useNavigate()

  // Chakra Color Mode
  let mainTeal = useColorModeValue("teal.300", "teal.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let searchIcon = useColorModeValue("gray.700", "gray.200");
  let textColor = useColorModeValue("#718196", "#f8f8f8");

  const logout = () => {
    signOut()
    navigate('/admin_area/signin')
  }

  return (
      <Flex
          pe={{ sm: "16px", md: "16px" }}
          w={{ sm: "100%", md: "auto" }}
          alignItems="center"
          flexDirection="row"
      >
        {/*Поиск */}
        <InputGroup
            cursor="pointer"
            bg={inputBg} borderRadius="15px"
            w={{ sm: "128px", md: "200px", }}
            me={{ sm: "auto", md: "20px" }}
            _focus={{ borderColor: { mainTeal }, }}
            _active={{ borderColor: { mainTeal },  }}
        >
          <InputLeftElement
              children={
                <IconButton
                    bg="inherit" borderRadius="inherit"
                    _hover={{}}
                    _active={{ bg: "inherit", transform: "none", borderColor: "transparent", }}
                    _focus={{ boxShadow: "none", }}
                    icon={<SearchIcon color={searchIcon} w="15px" h="15px" />}
                ></IconButton>
              }
          />
          <SearchBar
              initialValue={props.initialValue ?? ''}
              onChange={props.onChange}
              debounce={props.debounce}
          />
        </InputGroup>

        {/* меню */}

        <SidebarResponsive logoText={props.logoText} secondary={props.secondary} {...rest} />

        {/* лампочка */}
        <HiOutlineLightBulb
            cursor="pointer"
            onClick={toggleColorMode}
            style={{
              "marginLeft": "12px",
              "marginRight": "12px",
              "width": "20px",
              "height": "20px",
              "color": textColor
            }}

        />

        {/* выход */}
        <FiLogOut
            cursor="pointer"
            onClick={logout}
            style={{
              "width": "20px",
              "height": "20px",
              "color": textColor
            }}
        />
      </Flex>
  );
}
